import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/service/auth/auth.service';
import { SessionService } from '../../service/session/session.service';

@Component({
  selector: 'app-timeout-warning',
  templateUrl: './timeout-warning.component.html',
  styleUrls: ['./timeout-warning.component.css']
})
export class TimeoutWarningComponent implements OnInit {

  timeRemaining: Observable<number>;

  constructor(
    public dialogRef: MatDialogRef<TimeoutWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sessionService: SessionService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.getTimeRemaining();
    }
  }

  getTimeRemaining() {
    this.timeRemaining = this.sessionService.timeRemaining;
  }

  onDialogClose() {
    this.dialogRef.close();
    this.sessionService.setPopupActive(false);
    this.sessionService.resetIdleSessionTime();
  }

  logout() {
    this.sessionService.logout();
  }

}
